import { type ImageCardData, CardDataType, ComponentName} from "../types";
import { GenreType, type Genre } from "@ca.vmedia.tv/domains";

export class GenreCardData implements ImageCardData {

    private genre: Genre;

    constructor(genre: Genre) {
        this.genre = genre;
    }

    getId(): string {
        return `${this.genre.id}`;
    }

    getImage(): string {
        return this.genre.image ?? '';
    }

    getClass(): string {
        return 'channel-card';
    }

    getType(): CardDataType {
        return CardDataType.Channel;
    }

    getComponentName(): ComponentName {
        return ComponentName.CHANNEL;
    }

    getName(): string {
        return `${this.genre.name}`;
    }

    getIsPremium(): boolean {
        return this.genre.type === GenreType.Premium;
    }
}
